import React, {useContext} from 'react';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import {RootStoreContext} from "../../../../stores/root/root";

type Props = {
    dateString: string,
    showTime?: boolean,
    withSeconds?: boolean
    noStyle?: boolean
};

export const Date: React.FC<Props> = ({dateString, showTime, withSeconds, noStyle}) => {

    const {
        authStore: { lz },
    } = useContext(RootStoreContext);

    const getTimezone = (): string => {
        dayjs.extend(utc)
        dayjs.extend(timezone)
        let format = showTime ? "DD-MM-YYYY HH:mm" : "DD-MM-YYYY";
        if (showTime && withSeconds) {
            format = format + ":ss";
        }
//        return dayjs.tz(dayjs(dateString), lz.tz).format(format);
        return dayjs(dateString).format(format);
    }

    if (noStyle) {
        return <>{getTimezone()}</>
    }

    return (
        <span style={{whiteSpace: "pre"}}>
            {getTimezone()}
        </span>
    );
}
